<template>
  <div class="reports">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <search-form
            ref="searchform"
            :showDates="true"
            :results="liveFeed"
            :noResults="'No activity found for selected period.'"
            :options="{
              permalink: 'getLiveFeed'
            }">
          </search-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SearchForm from '@/components/SearchForm'
  import { mapGetters } from 'vuex'
  export default {
    name: 'LiveFeed',
    components: {
      SearchForm
    },
    computed: {
      ...mapGetters([
        'liveFeed'
      ])
    },
    data () {
      return {
        autoReloadTimer: ''
      }
    },
    mounted () {
      this.autoReloadTimer = setInterval(this.autoReload, 30000)
    },
    beforeDestroy () {
      clearInterval(this.autoReloadTimer)
    },
    methods: {
      autoReload () {
        this.$refs.searchform.refresh()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/admin/LiveFeed.vue